export default __webpack_public_path__ + "media/images/images_v2/action1-a1e356e42ea9d477be7b68023e4ce478.png";